import ObjectID from 'bson-objectid';
import { FormField } from 'components/shared/form';
import { OtherIncomeItem } from 'types/underwriting/income-approach';
import Form from 'mobx-react-form';

export const otherIncomeFormFields: FormField[] = [
  {
    name: 'incomeApproach',
    fields: [
      {
        name: 'otherIncome',
        type: 'array',
        value: [],
      },
    ],
  },
];

export const otherIncomeFormHelpers = {
  updateOtherIncomeItem: (form: Form, id: string, updatedOtherIncomeItem: OtherIncomeItem) => {
    const otherIncomeField = form.$('incomeApproach.otherIncome');
    const otherIncome = otherIncomeField.value || [];
    const updatedOtherIncome = otherIncome.map((income: OtherIncomeItem) => {
      if (income.id === id) {
        return updatedOtherIncomeItem;
      } else {
        return income;
      }
    });
    otherIncomeField.set(updatedOtherIncome);
  },
  addNewOtherIncomeItem: (form: Form) => {
    const otherIncomeField = form.$('incomeApproach.otherIncome');
    const newIncome = { id: new ObjectID().toHexString(), name: '', amount: 0, vcLossType: '', vcLossPercentage: 0 };
    otherIncomeField.add([newIncome]);
  },
  removeOtherIncomeItem: (form: Form, index: number) => {
    const otherIncomeField = form.$('incomeApproach.otherIncome') || [];
    const otherIncome = otherIncomeField.value || [];

    const lastIndex = otherIncome.length - 1;

    const newOtherIncome = otherIncome.filter((_: Record<string, any>, i: number) => i !== index);

    otherIncomeField.set(newOtherIncome);
    otherIncomeField.del(lastIndex);
  },
};
